/*
  Doma Crioula — Scripts flutuantes (extraído do theme.liquid para cache)
  Barra de localização + Popup de cupom + Botão WhatsApp
*/

/* ===== Barra superior de localização ===== */
  (function () {
    var cityEl = document.getElementById('doma-location-city');
    if (!cityEl) return;

    var promoEl = document.getElementById('doma-location-promo');

    var fallbackCity = 'sua região';
    var storageKey = 'doma_delivery_city_v2';
    var storageKeyUf = 'doma_delivery_uf_v2';

    // Promoção padrão (válida em todo o Brasil) + mensagens específicas por estado (UF).
    var promoPadrao = 'SEDEX grátis acima de R$ 350,00';
    var regiaoPromo = {
      RS: 'Frete SEDEX grátis no RS 🚚'
    };

    function applyRegionPromo(uf) {
      if (!promoEl) return;
      uf = (uf || '').toString().trim().toUpperCase();
      var msg = regiaoPromo[uf] || promoPadrao;
      promoEl.textContent = msg;
      promoEl.hidden = false;
    }

    // Mostra a promoção padrão imediatamente (antes mesmo do geo resolver).
    applyRegionPromo('');

    function setCity(city, uf) {
      if (!city || typeof city !== 'string') return;
      city = city.trim();

      if (!city || city.length < 2) return;

      cityEl.textContent = city;

      try {
        localStorage.setItem(storageKey, city);
        if (uf) localStorage.setItem(storageKeyUf, uf);
      } catch (e) {}

      applyRegionPromo(uf);
    }

    try {
      var cachedCity = localStorage.getItem(storageKey);
      var cachedUf = localStorage.getItem(storageKeyUf);
      if (cachedCity) {
        setCity(cachedCity, cachedUf);
        return;
      }
    } catch (e) {}

    // Timeout defensivo: se o ipapi.co demorar/cair, aborta em 3,5s e usa o fallback.
    var geoController = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var geoTimer = geoController
      ? setTimeout(function () { geoController.abort(); }, 3500)
      : null;

    fetch('https://ipapi.co/json/', {
      method: 'GET',
      cache: 'force-cache',
      signal: geoController ? geoController.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Localização indisponível');
        return response.json();
      })
      .then(function (data) {
        if (data && data.city) {
          // Customizado: mostra "Cidade - UF" quando o estado estiver disponível.
          var label = data.region_code ? data.city + ' - ' + data.region_code : data.city;
          setCity(label, data.region_code);
        } else {
          cityEl.textContent = fallbackCity;
        }
      })
      .catch(function () {
        cityEl.textContent = fallbackCity;
      })
      .finally(function () {
        if (geoTimer) clearTimeout(geoTimer);
      });
  })();

/* ===== Popup de cupom (WhatsApp) ===== */
  (function () {
    // Configurações vindas da section editável "Pop-up de Cupom" (com fallbacks).
    var POPUP_S = window.DOMA_POPUP_SETTINGS || {};
    if (POPUP_S.enabled === false) return; // liga/desliga pelo editor de tema (Pop-up de Cupom)
    const DOMA_POPUP_CONFIG = {
      fechadoDias: 7,
      capturadoDias: 90,
      atrasoAbertura: 3000,
      storageKey: "popupDomaWhatsapp5offV2",
      bubbleClosedKey: "popupDomaCouponBubbleClosed",
      origem: "popup-whatsapp-5off-3s"
    };

    const caminhosBloqueados = ["/cart", "/checkout", "/account"];
    const caminhoAtual = window.location.pathname;
    if (caminhosBloqueados.some((path) => caminhoAtual.indexOf(path) === 0)) return;

    const firebaseConfig = {
      apiKey: "AIzaSyDmITFZ6elPyEFMKFPNg_b1DKYRSvCMk8c",
      authDomain: "teste-860be.firebaseapp.com",
      projectId: "teste-860be",
      storageBucket: "teste-860be.firebasestorage.app",
      messagingSenderId: "572869829344",
      appId: "1:572869829344:web:0d09f9c522c32c1f9c6685"
    };

    let firebaseDomaPromise = null;
    let popupExibido = false;
    let fechamentoManualNaSessao = false;

    function carregarScriptDoma(src) {
      return new Promise((resolve, reject) => {
        const existente = document.querySelector(`script[src="${src}"]`);

        if (existente) {
          if (window.firebase) {
            resolve();
            return;
          }

          existente.addEventListener("load", resolve, { once: true });
          existente.addEventListener("error", reject, { once: true });
          return;
        }

        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    async function carregarFirebaseDoma() {
      if (firebaseDomaPromise) return firebaseDomaPromise;

      firebaseDomaPromise = (async () => {
        await carregarScriptDoma("https://www.gstatic.com/firebasejs/8.10.1/firebase-app.js");
        await carregarScriptDoma("https://www.gstatic.com/firebasejs/8.10.1/firebase-firestore.js");

        if (!firebase.apps.length) firebase.initializeApp(firebaseConfig);
        return firebase.firestore();
      })();

      return firebaseDomaPromise;
    }

    function diasEmMs(dias) {
      return dias * 24 * 60 * 60 * 1000;
    }

    function getStatusPopup() {
      try {
        return JSON.parse(localStorage.getItem(DOMA_POPUP_CONFIG.storageKey) || "null");
      } catch (e) {
        return null;
      }
    }

    function setStatusPopup(status) {
      try {
        localStorage.setItem(DOMA_POPUP_CONFIG.storageKey, JSON.stringify({
          status: status,
          timestamp: Date.now()
        }));
      } catch (e) {}
    }

    function statusCapturadoAtivo() {
      const status = getStatusPopup();
      if (!status || !status.timestamp) return false;
      const idade = Date.now() - status.timestamp;
      return status.status === "capturado" && idade <= diasEmMs(DOMA_POPUP_CONFIG.capturadoDias);
    }

    function podeMostrarAutomatico() {
      const status = getStatusPopup();
      if (!status || !status.timestamp) return true;

      const idade = Date.now() - status.timestamp;
      if (status.status === "capturado") return idade > diasEmMs(DOMA_POPUP_CONFIG.capturadoDias);
      if (status.status === "fechado") return idade > diasEmMs(DOMA_POPUP_CONFIG.fechadoDias);
      return true;
    }

    function bolhaCupomFechada() {
      try {
        return localStorage.getItem(DOMA_POPUP_CONFIG.bubbleClosedKey) === "true";
      } catch (e) {
        return false;
      }
    }

    function mostrarBolhaCupom() {
      const bolha = document.getElementById("domaCouponBubble");
      if (!bolha || statusCapturadoAtivo() || bolhaCupomFechada()) return;
      bolha.style.display = "flex";
    }

    function ocultarBolhaCupom() {
      const bolha = document.getElementById("domaCouponBubble");
      if (bolha) bolha.style.display = "none";
    }

    function fecharBolhaCupom() {
      try {
        localStorage.setItem(DOMA_POPUP_CONFIG.bubbleClosedKey, "true");
      } catch (e) {}
      ocultarBolhaCupom();
    }

    function mostrarBotaoCupom() {
      const botaoCupom = document.getElementById("domaCouponFloatingBtn");
      if (!botaoCupom || statusCapturadoAtivo()) return;

      botaoCupom.style.display = "flex";
      mostrarBolhaCupom();
    }

    function ocultarBotaoCupom() {
      const botaoCupom = document.getElementById("domaCouponFloatingBtn");
      if (botaoCupom) botaoCupom.style.display = "none";

      ocultarBolhaCupom();
    }

    function validarNome(valor) {
      const nome = valor.trim();

      if (nome.length < 3) return false;
      if (!/[a-zA-ZÀ-ÿ]/.test(nome)) return false;
      if (/^\d+$/.test(nome)) return false;

      return true;
    }

    function validarTelefoneBR(valor) {
      const digits = valor.replace(/\D/g, "");

      const dddsValidos = [
        "11","12","13","14","15","16","17","18","19",
        "21","22","24","27","28",
        "31","32","33","34","35","37","38",
        "41","42","43","44","45","46","47","48","49",
        "51","53","54","55",
        "61","62","63","64","65","66","67","68","69",
        "71","73","74","75","77","79",
        "81","82","83","84","85","86","87","88","89",
        "91","92","93","94","95","96","97","98","99"
      ];

      if (digits.length !== 11) return false;

      const ddd = digits.slice(0, 2);
      const primeiroDigitoCelular = digits.charAt(2);

      if (!dddsValidos.includes(ddd)) return false;
      if (primeiroDigitoCelular !== "9") return false;

      if (/^(\d)\1+$/.test(digits)) return false;
      if (digits.includes("12345678")) return false;
      if (digits.includes("000000")) return false;
      if (digits.includes("111111")) return false;
      if (digits.includes("999999")) return false;

      return true;
    }

    function formatarTelefoneBR(valor) {
      const digits = valor.replace(/\D/g, "").slice(0, 11);
      if (digits.length <= 2) return digits;
      if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
      if (digits.length <= 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    }

    function mostrarMensagem(texto, erro) {
      const msg = document.getElementById("popupDomaMsg");
      if (!msg) return;
      msg.textContent = texto;
      msg.style.display = "block";
      msg.style.color = erro ? "#ffb3a7" : "#d4aa4a";
    }

    window.fecharPopup = function (motivo) {
      const bg = document.getElementById("popupLeadBackdrop");
      if (bg) bg.remove();
      popupExibido = false;

      if (motivo === "capturado") {
        setStatusPopup("capturado");
        ocultarBotaoCupom();
        return;
      }

      fechamentoManualNaSessao = true;
      setStatusPopup("fechado");
      mostrarBotaoCupom();
    };

    window.abrirPopup = function (origemManual) {
      if (document.getElementById("popupLeadBackdrop")) return;
      if (statusCapturadoAtivo()) return;
      if (!origemManual && (!podeMostrarAutomatico() || fechamentoManualNaSessao)) return;

      popupExibido = true;
      ocultarBotaoCupom();

      const fundo = document.createElement("div");
      fundo.id = "popupLeadBackdrop";
      fundo.setAttribute("role", "dialog");
      fundo.setAttribute("aria-modal", "true");
      fundo.setAttribute("aria-labelledby", "popupDomaTitulo");

      fundo.innerHTML = `
        <div class="popup-doma-flip" id="popupDomaFlip">
          <div class="popup-doma-flip-inner">

            <div class="popup-doma-card popup-doma-front">
              <button class="popup-doma-close" type="button" onclick="fecharPopup('fechado')" aria-label="Fechar">×</button>

              <p class="popup-doma-kicker">${POPUP_S.kicker || 'Cupom no WhatsApp'}</p>
              <h2 id="popupDomaTitulo" class="popup-doma-title">${POPUP_S.title || 'Ganhe 5% OFF na sua peça Doma.'}</h2>
              <p class="popup-doma-text">${POPUP_S.description || 'Informe seu nome e WhatsApp para liberar seu cupom na hora.'}</p>

              <input id="nomeLead" class="popup-doma-input" placeholder="${POPUP_S.placeholderNome || 'Seu nome'}" autocomplete="name">

              <input id="telefoneLead" class="popup-doma-input" placeholder="${POPUP_S.placeholderTel || 'WhatsApp com DDD'}" inputmode="numeric" autocomplete="tel">

              <button id="btnEnviarLead" class="popup-doma-btn" type="button">${POPUP_S.buttonText || 'Receber cupom de 5%'}</button>

              <p id="popupDomaMsg" class="popup-doma-msg"></p>
              <p class="popup-doma-note">${POPUP_S.note || 'Ao solicitar, você autoriza contato da Doma Crioula pelo WhatsApp. Veja a <a href="/policies/privacy-policy" target="_blank" rel="noopener">Política de Privacidade</a>.'}</p>
              <button class="popup-doma-decline" type="button" onclick="fecharPopup('fechado')">${POPUP_S.declineText || 'Continuar sem cupom'}</button>
            </div>

            <div class="popup-doma-card popup-doma-back" aria-hidden="true">
              <button class="popup-doma-close" type="button" onclick="fecharPopup('capturado')" aria-label="Fechar">×</button>

              <div class="popup-doma-badge">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2 2 2 0 0 0 0 4 2 2 0 0 1-2 2H5a2 2 0 0 1-2-2 2 2 0 0 0 0-4z"></path><path d="M9 7v3"></path><path d="M9 14v3"></path></svg>
              </div>

              <p class="popup-doma-kicker popup-doma-kicker--center">${POPUP_S.revealKicker || 'Cupom liberado'}</p>
              <h2 class="popup-doma-title popup-doma-title--center">${POPUP_S.revealTitle || 'Seu cupom de 5% OFF'}</h2>
              <p class="popup-doma-text popup-doma-text--center">${POPUP_S.revealText || 'Copie o código e use no seu pedido.'}</p>

              <div class="popup-doma-code" id="popupDomaCode">${POPUP_S.couponCode || 'DOMA5'}</div>

              <button id="btnCopiarCupom" class="popup-doma-btn" type="button">${POPUP_S.copyText || 'Copiar cupom'}</button>
              <button id="btnAplicarCupom" class="popup-doma-apply" type="button">${POPUP_S.applyText || 'Aplicar e ir às compras'}</button>

              <p class="popup-doma-note popup-doma-note--center">${POPUP_S.revealNote || 'Válido na sua próxima compra. Não acumulativo com outros cupons.'}</p>
            </div>

          </div>
        </div>
      `;

      document.body.appendChild(fundo);

      fundo.addEventListener("click", (e) => {
        if (e.target.id === "popupLeadBackdrop") fecharPopup("fechado");
      });

      document.addEventListener("keydown", function escListener(e) {
        if (e.key === "Escape") {
          fecharPopup("fechado");
          document.removeEventListener("keydown", escListener);
        }
      });

      const nomeInput = document.getElementById("nomeLead");
      const telefoneInput = document.getElementById("telefoneLead");

      telefoneInput.addEventListener("input", function () {
        this.value = formatarTelefoneBR(this.value);
      });

      nomeInput.focus();

      document.getElementById("btnEnviarLead").addEventListener("click", enviarLead);

      var btnCopiar = document.getElementById("btnCopiarCupom");
      if (btnCopiar) btnCopiar.addEventListener("click", copiarCupom);

      var btnAplicar = document.getElementById("btnAplicarCupom");
      if (btnAplicar) btnAplicar.addEventListener("click", aplicarCupom);

      telefoneInput.addEventListener("keydown", function (e) {
        if (e.key === "Enter") enviarLead();
      });

      nomeInput.addEventListener("keydown", function (e) {
        if (e.key === "Enter") telefoneInput.focus();
      });
    };

    async function enviarLead() {
      const nomeInput = document.getElementById("nomeLead");
      const telInput = document.getElementById("telefoneLead");

      const nome = nomeInput.value.trim();
      const tel = telInput.value.trim();
      const telDigits = tel.replace(/\D/g, "");

      const botao = document.getElementById("btnEnviarLead");
      const textoOriginal = botao.textContent;

      if (!validarNome(nome)) {
        mostrarMensagem("Digite seu nome corretamente.", true);
        nomeInput.focus();
        return;
      }

      if (!validarTelefoneBR(telDigits)) {
        mostrarMensagem("Digite um WhatsApp válido com DDD. Exemplo: (51) 99999-9999", true);
        telInput.focus();
        return;
      }

      botao.disabled = true;
      botao.textContent = "Enviando...";
      mostrarMensagem("Registrando seus dados para liberar o cupom.", false);

      try {
        const db = await carregarFirebaseDoma();

        await db.collection("leads").add({
          nome: nome,
          telefone: telDigits,
          telefoneFormatado: tel,
          nomeTelefone: `${nome} - ${tel}`,
          whatsappValidoFormato: true,
          consentimento: "Solicitou cupom pelo pop-up de WhatsApp",
          criadoEm: new Date(),
          origem: DOMA_POPUP_CONFIG.origem,
          pagina: window.location.href,
          userAgent: navigator.userAgent
        });

        botao.textContent = "Pronto!";
        setStatusPopup("capturado");
        ocultarBotaoCupom();
        revelarCupom();
      } catch (error) {
        console.error("Erro ao salvar lead:", error);
        mostrarMensagem("Não consegui registrar agora. Tente novamente ou chame pelo botão de WhatsApp.", true);
        botao.disabled = false;
        botao.textContent = textoOriginal;
      }
    }

    function revelarCupom() {
      const codeEl = document.getElementById("popupDomaCode");
      if (codeEl) codeEl.textContent = POPUP_S.couponCode || "DOMA5";

      const frente = document.querySelector(".popup-doma-front");
      const verso = document.querySelector(".popup-doma-back");
      if (frente) frente.setAttribute("aria-hidden", "true");
      if (verso) verso.removeAttribute("aria-hidden");

      const flip = document.getElementById("popupDomaFlip");
      if (flip) flip.classList.add("is-flipped");

      const copyBtn = document.getElementById("btnCopiarCupom");
      if (copyBtn) setTimeout(() => copyBtn.focus(), 760);
    }

    function copiarParaAreaDeTransferencia(texto) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(texto);
      }
      return new Promise((resolve, reject) => {
        try {
          const ta = document.createElement("textarea");
          ta.value = texto;
          ta.setAttribute("readonly", "");
          ta.style.position = "fixed";
          ta.style.opacity = "0";
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
          resolve();
        } catch (e) {
          reject(e);
        }
      });
    }

    function copiarCupom() {
      const code = POPUP_S.couponCode || "DOMA5";
      const btn = document.getElementById("btnCopiarCupom");

      const feedback = () => {
        if (!btn) return;
        const original = btn.dataset.label || btn.textContent;
        btn.dataset.label = original;
        btn.textContent = "Copiado ✓";
        btn.classList.add("is-copied");
        setTimeout(() => {
          btn.textContent = original;
          btn.classList.remove("is-copied");
        }, 1800);
      };

      copiarParaAreaDeTransferencia(code).then(feedback).catch(feedback);
    }

    function aplicarCupom() {
      const code = POPUP_S.couponCode || "DOMA5";
      const redirect = POPUP_S.applyRedirect || "/collections/all";
      copiarParaAreaDeTransferencia(code).finally(() => {
        window.location.href = "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(redirect);
      });
    }

    function iniciarPopupDoma() {
      const botaoCupom = document.getElementById("domaCouponFloatingBtn");
      if (botaoCupom) {
        botaoCupom.addEventListener("click", function () {
          abrirPopup(true);
        });
      }

      const bolhaCupom = document.getElementById("domaCouponBubble");
      const fecharBolha = document.getElementById("domaCouponBubbleClose");

      if (bolhaCupom) {
        bolhaCupom.addEventListener("click", function () {
          abrirPopup(true);
        });
      }

      if (fecharBolha) {
        fecharBolha.addEventListener("click", function (e) {
          e.stopPropagation();
          fecharBolhaCupom();
        });
      }

      if (statusCapturadoAtivo()) {
        ocultarBotaoCupom();
        return;
      }

      if (!podeMostrarAutomatico()) {
        mostrarBotaoCupom();
        return;
      }

      // Auto-abertura só acontece se ligada na section. Por padrão fica desligada;
      // o botão flutuante de cupom continua visível para abertura manual.
      if (POPUP_S.autoOpen) {
        setTimeout(function () {
          abrirPopup(false);
        }, POPUP_S.autoDelay || DOMA_POPUP_CONFIG.atrasoAbertura);
      } else {
        mostrarBotaoCupom();
      }
    }

    document.addEventListener("DOMContentLoaded", iniciarPopupDoma);
  })();

/* ===== Botão flutuante WhatsApp ===== */
(function(){
  /* ── Configuração ── */
  var PHONE = '5551998795620';

  /* ── Monta a mensagem dinamicamente ── */
  function domaGetMessage(){
    var currentUrl = window.location.href;
    var path = window.location.pathname;
    var msg = '';

    /* Detecta se está em página de produto (Shopify usa /products/) */
    if(path.indexOf('/products/') !== -1){
      msg = 'Olá, vim do site e queria comprar uma faca, poderia me ajudar?\n\nEstou vendo este produto: ' + currentUrl;
    } else if(path.indexOf('/collections/') !== -1){
      msg = 'Olá, vim do site e queria comprar uma faca, poderia me ajudar?\n\nEstou olhando esta coleção: ' + currentUrl;
    } else {
      msg = 'Olá, vim do site e queria comprar uma faca, poderia me ajudar?';
    }

    return msg;
  }

  /* ── Abrir WhatsApp com mensagem dinâmica ── */
  window.domaWppOpen = function(){
    var message = domaGetMessage();
    var url = 'https://api.whatsapp.com/send?phone=' + PHONE + '&text=' + encodeURIComponent(message);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

})();
